// import Results from '../views/Results';

const routes = [
    // {path: '/dashboard', name: 'Dashboard', component: Index,       meta    : { layout : 'home',  requiresAuth : true, title : 'Home' }},
]

export default routes;